// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px;
}

.main-content {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.header {
  text-align: center;
  margin-bottom: 10px;
}

.header h1 {
  color: #333;
  font-size: 24px;
  font-weight: bold;
}

.card-body {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px; /* Unified padding for top and bottom */
}

.table-container {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 12px;
  border-bottom: 1px solid #dee2e6;
  text-align: left;
  vertical-align: top; /* Align content to the top */
}

.table th {
  background-color: #f2f2f2;
  font-weight: bold;
  font-size: 16px;
}

.table tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}

.active-status {
  color: #28a745;
  font-weight: bold;
}

.inactive-status {
  color: #dc3545;
  font-weight: bold;
}

.sim-status,
.generation {
  font-weight: bold;
  font-size: 14px;
}

/* Container to handle truncation */
.truncated-cell {
  max-width: 200px; /* Adjust the width based on your table design */
  white-space: nowrap; /* Prevents the text from wrapping */
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  cursor: pointer;
}

/* Tooltip styling */
.truncated-cell:hover::after {
  content: attr(data-full-text); /* Use the full text from data attribute */
  position: absolute;
  left: 0;
  top: 100%;
  background: #333;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  white-space: normal; /* Allow wrapping inside the tooltip */
  z-index: 10;
  width: max-content;
  max-width: 400px; /* Set max-width for the tooltip */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ActiveUsersTable.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa,EAAE,uCAAuC;AACxD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB,EAAE,6BAA6B;AACpD;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB,EAAE,gDAAgD;EAClE,mBAAmB,EAAE,oCAAoC;EACzD,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,6BAA6B,EAAE,0CAA0C;EACzE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB,EAAE,sCAAsC;EAC3D,WAAW;EACX,kBAAkB;EAClB,gBAAgB,EAAE,kCAAkC;EACpD,uCAAuC;EACvC,eAAe;AACjB","sourcesContent":[".container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 10px;\n}\n\n.main-content {\n  background-color: #f8f9fa;\n  border-radius: 10px;\n  padding: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.header {\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.header h1 {\n  color: #333;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.card-body {\n  background-color: #fff;\n  border-radius: 10px;\n  padding: 20px; /* Unified padding for top and bottom */\n}\n\n.table-container {\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table th,\n.table td {\n  padding: 12px;\n  border-bottom: 1px solid #dee2e6;\n  text-align: left;\n  vertical-align: top; /* Align content to the top */\n}\n\n.table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.table tbody tr:nth-child(even) {\n  background-color: #f8f9fa;\n}\n\n.active-status {\n  color: #28a745;\n  font-weight: bold;\n}\n\n.inactive-status {\n  color: #dc3545;\n  font-weight: bold;\n}\n\n.sim-status,\n.generation {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n/* Container to handle truncation */\n.truncated-cell {\n  max-width: 200px; /* Adjust the width based on your table design */\n  white-space: nowrap; /* Prevents the text from wrapping */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n  cursor: pointer;\n}\n\n/* Tooltip styling */\n.truncated-cell:hover::after {\n  content: attr(data-full-text); /* Use the full text from data attribute */\n  position: absolute;\n  left: 0;\n  top: 100%;\n  background: #333;\n  color: #fff;\n  padding: 5px 10px;\n  border-radius: 5px;\n  white-space: normal; /* Allow wrapping inside the tooltip */\n  z-index: 10;\n  width: max-content;\n  max-width: 400px; /* Set max-width for the tooltip */\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
